import React from 'react'

const Cart = () => {
  return (
    <div>
      style crt
    </div>
  )
}

export default Cart
